import { gql } from '@apollo/client';

export const GET_ABI_EXCHANGE_MESSAGES_FOR_AMS = gql`
  query getAbiExchangeMessagesForAMS(
    $input: ExchangeMessageSearchCriteriaInput!
    $searchPaginationInput: SearchPaginationInput!
  ) {
    getAbiExchangeMessages(
      input: $input
      searchPaginationInput: $searchPaginationInput
    ) {
      messages {
        json
        key
        time
        __typename
      }
      __typename
    }
  }
`;
